import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { Footer } from "../Footer";
import { secondaryGradient } from "../GradientBox";
import { Navigation } from "../navigation/Navigation";
import analytics from "../services/analytics";
import { FooterBackground } from "./FooterBackground";
import queryString from "query-string";

export const BiologicalAge: React.FC = () => {
  const location = useLocation();
  const queryStringParams = queryString.parse(location.search);
  const onlyRequiredQuestions =
    queryStringParams["onlyRequiredQuestions"] !== undefined;
  const useHealthReport = queryStringParams["healthReport"] !== undefined;
  const healthReportEvenInUnsupportedLocale =
    queryStringParams["healthReportEvenInUnsupportedLocale"] !== undefined;

  const calculatorUrl = queryString.stringifyUrl({
    url: "https://web-calculator-vika.web.app/",
    query: {
      onlyRequiredQuestions: onlyRequiredQuestions ? "1" : undefined,
      healthReport: useHealthReport ? "1" : undefined,
      healthReportEvenInUnsupportedLocale: healthReportEvenInUnsupportedLocale
        ? "1"
        : undefined,
    },
  });

  useEffect(() => {
    analytics.logPageView("biologicalAge");
  }, []);

  return (
    <Page>
      <Navigation />
      <div style={{ flex: 1 }}></div>
      <div style={{ minHeight: "640px" }}>
        <iframe
          style={{ border: 0 }}
          src={calculatorUrl}
          width="100%"
          height="640px"
        ></iframe>
      </div>
      <div style={{ flex: 1 }}></div>
      <FooterBackground>
        <Footer />
      </FooterBackground>
    </Page>
  );
};

export default BiologicalAge;

const Page = styled.div`
  display: flex;
  flex-direction: column;
  background: ${secondaryGradient};
  height: 100vh;
  overflow-y: auto;
`;
